// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34osp","textarea":"styles_textarea__2k4h8"};